import { atom } from "jotai";

const INITIAL_VALUE = null;

export const selectedInsightRowAtom = atom(INITIAL_VALUE);
